import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
	ADSENSE_CLIENT, pushAdUnit, shouldShowAds, isAdSenseEnabled,
} from '../../utils/adsense';
import '../../styles/adsense.scss';

/**
 * Manual AdSense display unit. Requires REACT_APP_ADSENSE_CLIENT_ID + a slot ID.
 * Renders nothing when env vars are unset (safe for dev/local builds).
 */
function AdSenseUnit({
	location,
	slot,
	format = 'auto',
	layout = 'display',
	className = '',
	label = 'Advertisement',
}) {
	const pushed = useRef(false);

	useEffect(() => {
		pushed.current = false;
	}, [location.pathname, slot]);

	useEffect(() => {
		if (!slot || !shouldShowAds(location.pathname) || pushed.current) return;
		pushAdUnit();
		pushed.current = true;
	}, [location.pathname, slot]);

	if (!isAdSenseEnabled() || !slot || !shouldShowAds(location.pathname)) {
		return null;
	}

	return (
		<aside
			className={`adsense-unit${className ? ` ${className}` : ''}`}
			aria-label={label}
			data-adsense-placement={layout}
		>
			<p className="adsense-unit__label">{label}</p>
			<div className="adsense-unit__frame">
				<ins
					className="adsbygoogle"
					style={{ display: 'block' }}
					data-ad-client={ADSENSE_CLIENT}
					data-ad-slot={slot}
					data-ad-format={format}
					data-full-width-responsive="true"
				/>
			</div>
		</aside>
	);
}

export default withRouter(AdSenseUnit);
